import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Icon, Card, DatePicker, Divider, Spin } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import userProfileImageHolder from '../user_profile.jpg';
import SearchBar from './SearchBar'
import moment from 'moment';
import { geocodeByAddress } from 'react-places-autocomplete';
import Image from 'react-image-resizer';

import { useMediaQuery } from 'react-responsive'

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 992 })
  return isDesktop ? children : null
}
const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
  return isTablet ? children : null
}
const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  return isMobile ? children : null
}
const Default = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: 768 })
  return isNotMobile ? children : null
}

const API_HOST_URL = process.env.REACT_APP_API_URL

const style = {
  profileImage: {
    display: 'inline',
    margin: '0 auto',
    // marginLeft: '-25%',
    height: '100%',
    width: 'auto'
  },
  vehicleImage: {
    display: 'inline',
    margin: '0 auto',
    height: '100%',
    width: 'auto',
    borderRadius: '5%'
  },
};

class FindRide extends Component {
  state = {
    fromSearch: '',
    fromValue: '',
    toSearch: '',
    toValue: '',
    trips: [],

    from_address: '',
    from_errorMessage: '',
    from_latitude: null,
    from_longitude: null,

    to_address: '',
    to_errorMessage: '',
    to_latitude: null,
    to_longitude: null,

    originCity: '',
    destinationCity: '',

    loading: false
  }

  componentDidMount() {
    this.fetchData(this.state.originCity, this.destinationCity);
  }


  fetchData = (originCity, destinationCity) => {
    this.setState({
      loading: true
    })
    let _destinationCity = destinationCity;
    if (_destinationCity === undefined){
      _destinationCity = ''
    }
    axios.get(`${API_HOST_URL}/api/trips/?expand=user&ordering=-id&originCity=${originCity}&destinationCity=${_destinationCity}`)
      .then(res => {
        this.setState({
          trips: res.data,
          loading: false
        },
          () => {
            console.log("trips fetched: ", this.state.trips)
          })
      })
  }

  findTrips(originCity, destinationCity) {
    this.fetchData(originCity, destinationCity);
  }

  //   Map from operations
  from_handleChange = from_address => {
    this.setState({
      from_address,
    });
  };

  from_handleSelect = selected => {
    this.setState({ from_address: selected });
    geocodeByAddress(selected)
      .then(response => {
        console.log("origin geocodeByAddress result: ", response[0])

        //latitude and longitude
        const latitude = response[0].geometry.location.lat()
        const longitude = response[0].geometry.location.lng()
        console.log("origin geometry lat lng: ", latitude, longitude)

        this.setState({
          from_latitude: latitude,
          from_longitude: longitude,
        });

        console.log("the type of coordinate:", typeof latitude, typeof this.state.from_latitude)

        //city address
        const address_components = response[0].address_components;
        for (let i = 0; i < address_components.length; i++) {
          if (address_components[i].types.indexOf("locality") != -1 && address_components[i].types.indexOf("political") != -1) {
            console.log("origin city: ", address_components[i].long_name)
            this.setState({
              originCity: address_components[i].long_name
            });
          }
        }
      })
      .catch(error => {
        console.log('error', error); // eslint-disable-line no-console
      });
  };

  from_handleCloseClick = () => {
    this.setState({
      from_address: '',
      from_latitude: null,
      from_longitude: null,
      originCity: ''
    });
  };

  //   Map from operations
  to_handleChange = to_address => {
    this.setState({
      to_address,
    });
  };

  to_handleSelect = selected => {
    this.setState({ to_address: selected });
    geocodeByAddress(selected)
      .then(response => {
        console.log("destination geocodeByAddress result: ", response[0])

        //latitude and longitude
        const latitude = response[0].geometry.location.lat()
        const longitude = response[0].geometry.location.lng()
        console.log("destination geometry lat lng: ", latitude, longitude)

        this.setState({
          to_latitude: latitude,
          to_longitude: longitude,
        });

        //city address
        const address_components = response[0].address_components;
        for (let i = 0; i < address_components.length; i++) {
          if (address_components[i].types.indexOf("locality") != -1 && address_components[i].types.indexOf("political") != -1) {
            console.log("destination city: ", address_components[i].long_name)
            this.setState({
              destinationCity: address_components[i].long_name
            });
          }
        }
      })
      .catch(error => {
        console.log('error', error); // eslint-disable-line no-console
      });
  };

  to_handleCloseClick = () => {
    this.setState({
      to_address: '',
      to_latitude: null,
      to_longitude: null,
      destinationCity: ''
    });
  };

  getPrimaryVehicle(vehicles) {
    console.log("vehicles: ", vehicles)
    let primaryVehicle = {}
    let filteredVehicles = []
    if (typeof vehicles !== undefined) {
      if (vehicles.length() > 0) {
        filteredVehicles = vehicles.filter(vehicle => vehicle.primaryVehicle === true)
      }
      if (filteredVehicles.length() > 0) {
        primaryVehicle = filteredVehicles[0]
      }
    }

    return primaryVehicle
  }


  render() {
    const { trips, loading } = this.state

    return (
      <div>
        <div style={{ padding: 0 }}>
          <Desktop>
            <Card style={{ backgroundColor: '#00abff' }}>
              <Row gutter={0}>

                <Col md={{ span: 6, offset: 3 }} sm={24}>
                  <SearchBar
                    inputIconStyle="icon_from"
                    handleChange={this.from_handleChange}
                    address={this.state.from_address}
                    handleSelect={this.from_handleSelect}
                    placeholder='From'
                    handleCloseClick={this.from_handleCloseClick}
                    showCloseIcon={this.state.from_latitude != null && this.state.from_longitude != null} />
                </Col>

                <Col md={6} sm={24}>
                  <SearchBar
                    inputIconStyle="icon_to"
                    handleChange={this.to_handleChange}
                    address={this.state.to_address}
                    handleSelect={this.to_handleSelect}
                    placeholder='To'
                    handleCloseClick={this.to_handleCloseClick}
                    showCloseIcon={this.state.to_latitude != null && this.state.to_longitude != null} />
                </Col>

                <Col md={6} sm={24} xs={24}>
                  {/* <DatePicker size="large" onChange={this.onChange} placeholder="Leaving when ?" /> &nbsp; */}
                  <Button loading={loading} onClick={()=>this.findTrips(this.state.originCity, this.state.destinationCity)} size="large" type="primary" style={{ backgroundColor: '#002766', borderColor: '#002766' }}>
                    <Icon type="search" />Search
                </Button>
                </Col>
              </Row>

            </Card>
          </Desktop>

          <Tablet>
            <Card style={{ backgroundColor: '#00abff' }}>
              <Row gutter={0}>

                <Col md={{ span: 6, offset: 3 }} sm={24}>
                  <SearchBar
                    inputIconStyle="icon_from"
                    handleChange={this.from_handleChange}
                    address={this.state.from_address}
                    handleSelect={this.from_handleSelect}
                    placeholder='From'
                    handleCloseClick={this.from_handleCloseClick}
                    showCloseIcon={this.state.from_latitude != null && this.state.from_longitude != null} />
                </Col>

                <Col md={6} sm={24}>
                  <SearchBar
                    inputIconStyle="icon_to"
                    handleChange={this.to_handleChange}
                    address={this.state.to_address}
                    handleSelect={this.to_handleSelect}
                    placeholder='To'
                    handleCloseClick={this.to_handleCloseClick}
                    showCloseIcon={this.state.to_latitude != null && this.state.to_longitude != null} />
                </Col>

                <Col md={6} sm={24} xs={24}>
                  {/* <DatePicker size="large" onChange={this.onChange} placeholder="Leaving when ?" /> &nbsp; */}
                  <Button loading={loading} onClick={()=>this.findTrips(this.state.originCity, this.state.destinationCity)} size="large" type="primary" style={{ backgroundColor: '#002766', borderColor: '#002766' }}>
                    <Icon type="search" />Search
                </Button>
                </Col>
              </Row>

            </Card>
          </Tablet>

          <Mobile>
            <Card style={{ backgroundColor: '#00abff' }}>
              <Row gutter={0}>

                <Col sm={24}>
                  <SearchBar
                    inputIconStyle="icon_from"
                    handleChange={this.from_handleChange}
                    address={this.state.from_address}
                    handleSelect={this.from_handleSelect}
                    placeholder='From'
                    handleCloseClick={this.from_handleCloseClick}
                    showCloseIcon={this.state.from_latitude != null && this.state.from_longitude != null}
                    style={{ width: '100%' }} />
                </Col>
              </Row>
              <br/>

              <Row>
                <Col sm={24}>
                  <SearchBar
                    inputIconStyle="icon_to"
                    handleChange={this.to_handleChange}
                    address={this.state.to_address}
                    handleSelect={this.to_handleSelect}
                    placeholder='To'
                    handleCloseClick={this.to_handleCloseClick}
                    showCloseIcon={this.state.to_latitude != null && this.state.to_longitude != null} />
                </Col>
              </Row>
              <br />
              <Row>
                <Col sm={24} >
                  {/* <DatePicker size="large" onChange={this.onChange} placeholder="Leaving when ?" /> &nbsp; */}
                  <Button loading={loading} onClick={()=>this.findTrips(this.state.originCity, this.state.destinationCity)} size="large" type="primary" style={{ backgroundColor: '#002766', borderColor: '#002766', width: '95%' }}>
                    <Icon type="search" />Search
                </Button>
                </Col>
              </Row>

            </Card>
          </Mobile>


          <Desktop>
          <Spin spinning={loading} tip="finding rides....">
            <div style={{ padding: '10px' }}>

              <Row>
                <Col md={{ span: 18, offset: 3 }} sm={24}>
                  <h2 style={{ paddingTop: '10px', paddingLeft: '20px' }} className="GrayText">Available Rides</h2>
                </Col>

                {

                  trips.map(trip => (
                    <Link to={`trip-detail/${trip.id}`} key={trip.id}>
                      <Col md={{ span: 18, offset: 3 }} sm={24}>
                        <div style={{ padding: '5px' }}>
                          <Card>
                            <Row>
                              <Col md={{ span: 6 }}>
                                <div style={{ borderWidth: '0px', borderStyle: "solid", borderColor: '#4c4c4c' }}>
                                  <Row>
                                    <Col md={{ span: 12 }} sm={{ span: 12 }}>
                                      <div className="image-cropper">
                                        <Image
                                          src={trip.user.profilePhoto !== null ? trip.user.profile.profilePhoto : userProfileImageHolder}
                                          height={100}
                                          width={100}
                                          style={style.profileImage}
                                        />
                                        {/* <img src={trip.user.profilePhoto !== null ? trip.user.profile.profilePhoto: userProfileImageHolder} className="profile-pic" alt="logo" /> */}
                                      </div>

                                      {/* <img src={trip.user.profilePhoto !== null ? trip.user.profile.profilePhoto: userProfileImageHolder} className="UserProfileImage" alt="logo" /> */}
                                    </Col>
                                    <Col md={{ span: 12 }} sm={{ span: 12 }}>
                                      <h3 style={{ fontWeight: "bold" }} className="GrayText">{trip.user.last_name}</h3>
                                      <h4 style={{ fontWeight: "normal" }} className="GrayText">
                                        {trip.user.profile.gender}
                                        {/* , 32 */}
                                      </h4>
                                      {/* <h4 style={{ fontWeight: "bold", color: '#0099ff' }}><Icon type="user" theme="filled" /> 10 Driven</h4>
                                    <h4 style={{ fontWeight: "bold", color: '#0099ff' }}><Icon type="star" theme="filled" /> 5.0</h4>
                                    <h4 style={{ fontWeight: "normal", color: '#0099ff' }}>5 Reviews</h4> */}
                                    </Col>
                                  </Row>
                                </div>
                              </Col>

                              <Col md={{ span: 10 }}>
                                <h2 style={{ color: '#0099ff' }}>
                                  {/* <Link to="/trip-detail"> {trip.originCity} to {trip.destinationCity} </Link> */}
                                  {trip.originCity} to {trip.destinationCity}
                                </h2>

                                <h4 className="GrayText">Leaving    {moment(trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(trip.departureTime, "hh:mm").format("hh:mm A")}</h4>

                                <br />
                                <h4 style={{ fontWeight: "normal" }} className="GrayText">Pickup:    {trip.originCity}</h4>
                                <h4 style={{ fontWeight: "normal" }} className="GrayText">Drop Off:    {trip.destinationCity}</h4>
                              </Col>
                              <Col md={{ span: 8 }}>
                                {/* <img 
                              src={caImage} 
                              className="UserProfileImage" 
                              alt="logo" /> */}
                                <Image
                                  src={trip.user.primary_vehicle.length > 0 && API_HOST_URL + trip.user.primary_vehicle[0].vehiclePhoto}
                                  height={100}
                                  width={150}
                                // style={style.vehicleImage}
                                />
                                <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                  {
                                    trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].vehicleModel + ', '
                                  }
                                  <span>
                                    {
                                      trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].numberPlate
                                    }
                                  </span>
                                </h3>

                                <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                  {
                                    trip.numberOfSeats > 0 ?
                                      <span style={{ fontWeight: "bold" }}>{trip.numberOfSeats} seats left </span>
                                      :
                                      <span style={{ fontWeight: "bold" }}>Trip full </span>
                                  }
                                  <NumberFormat value={trip.pricePerSeat} displayType={'text'} thousandSeparator={true} prefix={'Ush '} style={{ color: "#05ac09", fontWeight: "bold" }} />
                                  <span> per seat</span>

                                </h3>
                              </Col>
                            </Row>
                          </Card>
                        </div>
                      </Col>
                    </Link>
                  )).sort()
                }

              </Row>
            </div>
            </Spin>
          </Desktop>

          <Tablet>
          <Spin spinning={loading} tip="finding rides....">
            <div style={{ padding: '10px' }}>

              <Row>
                <Col md={{ span: 18, offset: 3 }} sm={24}>
                  <h2 style={{ paddingTop: '10px', paddingLeft: '20px' }} className="GrayText">Available Rides</h2>
                </Col>

                {

                  trips.map(trip => (
                    <Link to={`trip-detail/${trip.id}`} key={trip.id}>
                      <Col md={{ span: 18, offset: 3 }} sm={24}>
                        <div style={{ padding: '5px' }}>
                          <Card>
                            <Row>
                              <Col md={{ span: 6 }}>
                                <div style={{ borderWidth: '0px', borderStyle: "solid", borderColor: '#4c4c4c' }}>
                                  <Row>
                                    <Col md={{ span: 12 }} sm={{ span: 12 }}>
                                      <div className="image-cropper">
                                        <Image
                                          src={trip.user.profilePhoto !== null ? trip.user.profile.profilePhoto : userProfileImageHolder}
                                          height={100}
                                          width={100}
                                          style={style.profileImage}
                                        />
                                        {/* <img src={trip.user.profilePhoto !== null ? trip.user.profile.profilePhoto: userProfileImageHolder} className="profile-pic" alt="logo" /> */}
                                      </div>

                                      {/* <img src={trip.user.profilePhoto !== null ? trip.user.profile.profilePhoto: userProfileImageHolder} className="UserProfileImage" alt="logo" /> */}
                                    </Col>
                                    <Col md={{ span: 12 }} sm={{ span: 12 }}>
                                      <h3 style={{ fontWeight: "bold" }} className="GrayText">{trip.user.last_name}</h3>
                                      <h4 style={{ fontWeight: "normal" }} className="GrayText">
                                        {trip.user.profile.gender}
                                        {/* , 32 */}
                                      </h4>
                                      {/* <h4 style={{ fontWeight: "bold", color: '#0099ff' }}><Icon type="user" theme="filled" /> 10 Driven</h4>
                                    <h4 style={{ fontWeight: "bold", color: '#0099ff' }}><Icon type="star" theme="filled" /> 5.0</h4>
                                    <h4 style={{ fontWeight: "normal", color: '#0099ff' }}>5 Reviews</h4> */}
                                    </Col>
                                  </Row>
                                </div>
                              </Col>

                              <Col md={{ span: 10 }}>
                                <h2 style={{ color: '#0099ff' }}>
                                  {/* <Link to="/trip-detail"> {trip.originCity} to {trip.destinationCity} </Link> */}
                                  {trip.originCity} to {trip.destinationCity}
                                </h2>

                                <h4 className="GrayText">Leaving    {moment(trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(trip.departureTime, "hh:mm").format("hh:mm A")}</h4>

                                <br />
                                <h4 style={{ fontWeight: "normal" }} className="GrayText">Pickup:    {trip.originCity}</h4>
                                <h4 style={{ fontWeight: "normal" }} className="GrayText">Drop Off:    {trip.destinationCity}</h4>
                              </Col>
                              <Col md={{ span: 8 }}>
                                {/* <img 
                              src={caImage} 
                              className="UserProfileImage" 
                              alt="logo" /> */}
                                <Image
                                  src={trip.user.primary_vehicle.length > 0 && API_HOST_URL + trip.user.primary_vehicle[0].vehiclePhoto}
                                  height={100}
                                  width={150}
                                // style={style.vehicleImage}
                                />
                                <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                  {
                                    trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].vehicleModel + ', '
                                  }
                                  <span>
                                    {
                                      trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].numberPlate
                                    }
                                  </span>
                                </h3>

                                <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                  {
                                    trip.numberOfSeats > 0 ?
                                      <span style={{ fontWeight: "bold" }}>{trip.numberOfSeats} seats left </span>
                                      :
                                      <span style={{ fontWeight: "bold" }}>Trip full </span>
                                  }
                                  <NumberFormat value={trip.pricePerSeat} displayType={'text'} thousandSeparator={true} prefix={'Ush '} style={{ color: "#05ac09", fontWeight: "bold" }} />
                                  <span> per seat</span>

                                </h3>
                              </Col>
                            </Row>
                          </Card>
                        </div>
                      </Col>
                    </Link>
                  )).sort()
                }

              </Row>
            </div>
            </Spin>
          </Tablet>

          <Mobile>
          <Spin spinning={loading} tip="finding rides....">
            <div style={{ padding: '10px' }}>

              <Row>
                <Col md={{ span: 18, offset: 3 }} sm={24}>
                  <h2 style={{ paddingTop: '10px', paddingLeft: '20px' }} className="GrayText">Available Rides</h2>
                </Col>

                {

                  trips.map(trip => (
                    <Link to={`trip-detail/${trip.id}`} key={trip.id}>
                      <Col sm={24}>
                        <div style={{ padding: '5px' }}>
                          <Card>
                            <Row>
        
                              <Col sm={{ span: 24 }}>
                                <h2 style={{ color: '#0099ff' }}>
                                  {/* <Link to="/trip-detail"> {trip.originCity} to {trip.destinationCity} </Link> */}
                                  {trip.originCity} to {trip.destinationCity}
                                </h2>

                                <h4 className="GrayText">{moment(trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(trip.departureTime, "hh:mm").format("hh:mm A")}</h4>
                                <br />
                              </Col>
                              <Col sm={{ span: 24 }}>
                              <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                  {
                                    trip.numberOfSeats > 0 ?
                                      <span style={{ fontWeight: "bold" }}>{trip.numberOfSeats} seats left, </span> 
                                      :
                                      <span style={{ fontWeight: "bold" }}>Trip full, </span>
                                  }
                                  <NumberFormat value={trip.pricePerSeat} displayType={'text'} thousandSeparator={true} prefix={'Ush '} style={{ color: "#05ac09", fontWeight: "bold" }} />
                                  <span style={{fontWeight: 'normal', fontStyle: 'italic'}}> (per seat) </span>

                                </h3>

                                <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                  {
                                    trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].vehicleModel + ', '
                                  }
                                  <span>
                                    {
                                      trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].numberPlate
                                    }
                                  </span>
                                </h3>   
                              </Col>
                            </Row>
                            <Divider/>
                            <Row>
                            <Col sm={{ span: 24 }}>
                                <div style={{ borderWidth: '0px', borderStyle: "solid", borderColor: '#4c4c4c' }}>
                                  <Row>
                                    <Col span={6}>
                                      <div className="image-cropper-mobile">
                                        <Image
                                          src={trip.user.profilePhoto !== null ? trip.user.profile.profilePhoto : userProfileImageHolder}
                                          height={60}
                                          width={60}
                                          style={style.profileImage}
                                        />
                                      </div>

                                    </Col>
                                    <Col span={18} style={{ marginTop: '1em' }}>
                                      <h3 style={{ fontWeight: "bold" }} className="GrayText">{trip.user.first_name + ' ' +trip.user.last_name}, {trip.user.profile.gender}</h3>
                                      {/* <h4 style={{ fontWeight: "normal" }} className="GrayText">
                                        {trip.user.profile.gender}
                                      </h4> */}
                                      </Col>
                                  </Row>
                                </div>
                              </Col>
                              </Row>
                          </Card>
                        </div>
                      </Col>
                    </Link>
                  )).sort()
                }

              </Row>
            </div>
            </Spin>
          </Mobile>
        </div>
      </div>
    );
  }
}


export default FindRide;
